const supportedFlags = ['ae', 'al', 'am', 'at', 'au', 'ba', 'be', 'bg', 'bh', 'br', 'by', 'ca', 'ch', 'cl', 'cn', 'co', 'cy', 'cz', 'de', 'dk', 'do', 'ee', 'eg', 'es', 'eu', 'fi', 'fr', 'gb', 'ge', 'gr', 'hk', 'hr', 'hu', 'id', 'ie', 'il', 'in', 'is', 'it', 'jo', 'jp', 'kp', 'kr', 'kw', 'lb', 'li', 'lt', 'lu', 'lv', 'ma', 'md', 'me', 'mk', 'mx', 'my', 'mt', 'ng', 'nl', 'no', 'nz', 'om', 'ph', 'pl', 'pt', 'qa', 'ro', 'rs', 'ru', 'sa', 'se', 'sg', 'si', 'sk', 'th', 'tr', 'ua', 'uk', 'us', 'vn', 'xk', 'za'];
const NAME_TO_FLAG = {};
supportedFlags.forEach(flag => NAME_TO_FLAG[`flag-${flag}`] = flag);
export const getFlagUrl = name => {
  const flag = NAME_TO_FLAG[name.toLowerCase()];
  if (flag) {
    return `${"https://d1uznvntk80v7s.cloudfront.net"}/flags/${flag}.svg`;
  }
  console.error(`kat-icon: The flag ${name} is not supported.`);
};
//# sourceMappingURL=name-to-flag.js.map